import { useState } from "react";
import { Form, Button } from "react-bootstrap";
import SearchableSelect from "../../../Components/SearchableSelect";

export default function NewActivity({
    workItemId,
    control,
    onCreate,
    loadUserOptions
}) {

    const [model, setModel] = useState({
        Message: "",
        CommentByID: null,
        CommentByName: ""
    });

    const [loading, setLoading] = useState(false);

    // =====================
    // HANDLERS
    // =====================

    const handleMessageChange = (e) => {
        setModel(prev => ({
            ...prev,
            Message: e.target.value
        }));
    };

    const handleUserSelect = (opt) => {
        setModel(prev => ({
            ...prev,
            CommentByID: opt?.value,
            CommentByName: opt?.label
        }));
    };

    const resetForm = () => {
        setModel({
            Message: "",
            CommentByID: null,
            CommentByName: ""
        });
    };

    const handleSubmit = async () => {

        if (!model.Message?.trim()) return;

        setLoading(true);

        const payload = {
            ...model,
            WorkItemID: workItemId
        };

        const result = await onCreate?.(payload);

        setLoading(false);

        // success = no error message
        if (!result?.Error) {
            resetForm();
        }
    };

    // =====================
    // RENDER
    // =====================

    return (
        <div className="workitem-new-comment">
            <div className="mt-2 form-group col-md-2">
                <SearchableSelect
                    control={control}
                    name="CommentByID"
                    value={model.CommentByID}
                    defaultLabel={model.CommentByName}
                    placeholder="انتخاب صاحب یادداشت..."
                    loadOptions={loadUserOptions}
                    onChange={handleUserSelect}
                />
            </div>
            <Form.Group>
                <Form.Control
                    as="textarea"
                    rows={2}
                    placeholder="نوشتن یادداشت فعالیت..."
                    value={model.Message}
                    onChange={handleMessageChange}
                />
            </Form.Group>

            <div className="mt-2 d-flex justify-content-start">

                <Button
                    variant="primary"
                    size="sm"
                    disabled={loading}
                    onClick={handleSubmit}
                >
                    {loading ? "در حال ثبت..." : "ثبت یادداشت فعالیت"}
                </Button>

            </div>

        </div>
    );
}